import { motion } from 'framer-motion';
import { sectionAnimVariants } from '../../../constants/animationVariants';
import { useCityContext } from '../../../contexts/CityProvider';
import useCheckUserFeaturePermissions from '../../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import SetupCard from '../../CommonComps/Cards/SetupCard';
import SetupCardBodyInfo from '../../CommonComps/Cards/SetupCardBodyInfo';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import NoTableDataFound from '../../CommonComps/NoTableDataFound';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import AddCityAction from './AddCityAction';
import FilterCitiesDiv from './FilterCitiesDiv';

const ShowAllCities = () => {
  // integration of context hooks here
  const {
    cityList,
    showDeleteCityModalHandler,
    showEditCityModalHandler,
    isLoading,
    isSuccess,
    isError,
  } = useCityContext();

  // integration of custom hooks here
  const { featureBasedPermissions } = useCheckUserFeaturePermissions('city');

  // rendering show all cities section component here
  return (
    <section>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader
              headerText='All Cities'
              additionalComponent={
                <AddCityAction
                  hasCreatePermission={featureBasedPermissions.includes(
                    'CREATE'
                  )}
                />
              }
            />

            <motion.div
              variants={sectionAnimVariants}
              initial='initial'
              animate='animate'
            >
              <FilterCitiesDiv />

              {cityList.length ? (
                <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5 px-2'>
                  {cityList.map((city) => (
                    <SetupCard
                      key={city.id}
                      title={city.city_name}
                      label={city.city_name}
                      editBtnTitle='Edit City'
                      deleteBtnTitle='Delete City'
                      showDeleteModalHandler={
                        featureBasedPermissions.includes('DELETE')
                          ? () => showDeleteCityModalHandler(city)
                          : undefined
                      }
                      showEditModalHandler={
                        featureBasedPermissions.includes('UPDATE')
                          ? () => showEditCityModalHandler(city)
                          : undefined
                      }
                    >
                      <SetupCardBodyInfo
                        label='Province'
                        info={city.province_name}
                      />
                    </SetupCard>
                  ))}
                </div>
              ) : (
                <NoTableDataFound message='No Cities Found!!' />
              )}
            </motion.div>
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : isError ? (
        <AcademiaNotFound message='Failed to load city Data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllCities;
